export default __webpack_public_path__ + "static/media/view-calendar.0eba16fb.svg";